module.exports = __webpack_public_path__ + "static/media/commerical-4.a6ca8b32.jpg";